/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "onboarding": {
        "nested": {
          "recommendations": {
            "nested": {
              "common": {
                "nested": {
                  "Product": {
                    "values": {
                      "PRODUCT_UNKNOWN": 0,
                      "PRODUCT_APPOINTMENTS": 1,
                      "PRODUCT_INVOICES": 2,
                      "PRODUCT_SPOS": 3,
                      "PRODUCT_RESTAURANTS": 4,
                      "PRODUCT_RETAIL": 5,
                      "PRODUCT_ONLINE_CHECKOUT": 6,
                      "PRODUCT_ONLINE_STORE": 7,
                      "PRODUCT_VIRTUAL_TERMINAL": 8
                    }
                  },
                  "Addon": {
                    "values": {
                      "ADDON_UNKNOWN": 0,
                      "ADDON_GIFT_CARDS": 1,
                      "ADDON_LOYALTY": 2,
                      "ADDON_MARKETING_EMAIL": 3,
                      "ADDON_MARKETING_TEXT_MSG": 4,
                      "ADDON_PAYROLL": 5,
                      "ADDON_TEAM_MANAGEMENT": 6,
                      "ADDON_SHIFTS": 7,
                      "ADDON_TEAM_COMMUNICATION": 8,
                      "ADDON_STAFF": 9
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.onboarding?.nested?.recommendations?.nested?.common?.nested?.Product && !$root.nested?.squareup?.nested?.onboarding?.nested?.recommendations?.nested?.common?.nested?.Addon) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE Product @ squareup/onboarding/recommendations/common.proto at 8:1
 */
export const Product = $root.lookupEnum('squareup.onboarding.recommendations.common.Product').values;
/**
 * SOURCE Addon @ squareup/onboarding/recommendations/common.proto at 20:1
 */
export const Addon = $root.lookupEnum('squareup.onboarding.recommendations.common.Addon').values;
